import React from 'react';
import './DiagnosisContent.css'; // Assuming you have a CSS file for styling

const DiagnosisContent = () => {
  return (
    <div className="periodontal-diagnosis-container">
      <div className="periodontal-diagnosis-overview-container">
          <div className="periodontal-diagnosis-overview-info">
            <h2 className="periodontal-diagnosis-overview-header">Periodontal Disease Diagnosis</h2>
            <div className="periodontal-diagnosis-custom-line"></div>
            <div className="periodontal-diagnosis-custom-line"></div>
            <p className="periodontal-diagnosis-text">
              Periodontal disease is diagnosed by your dentist or dental hygienist during a periodontal examination.  This type of exam should always be part of your regular dental check-up.
            </p>
            <p className="periodontal-diagnosis-text">
              A periodontal probe (small dental instrument) is gently used to measure the sulcus (pocket or space) between the tooth and the gums.  The depth of a healthy sulcus measures three millimeters or less and does not bleed.  The periodontal probe helps indicate if pockets are deeper than three millimeters.  As periodontal disease progresses, the pockets usually get deeper.
            </p>
          </div>

          <div className="periodontal-diagnosis-image-container">
            <img 
              src="/images/diagnosis-content.jpeg" 
              alt="Composite Fillings" 
              className="periodontal-diagnosis-1"
            />
          </div>
      </div>

      <div className="periodontal-diagnosis-description-container">
        <div className="first-row-diagnosis-container">
          <div className="periodontal-diagnosis-reasons-container">
            <h3 className="periodontal-diagnosis-reasons-header">Symptoms of Periodontal Disease</h3>
            <ul className="periodontal-diagnosis-reasons-list">
              <li>Bleeding gums</li>
              <li>Loose teeth</li>
              <li>New spacing between teeth</li>
              <li>Persistent bad breath</li>
              <li>Pus around teeth and gums</li>
              <li>Receding gums</li>
              <li>Red and puffy gums</li>
              <li>Tenderness of discomfort</li>
            </ul>
          </div>

          <div className="periodontal-diagnosis-steps-container">
            <h3 className="periodontal-diagnosis-steps-header">Types of Diagnoses</h3>
            <p className="periodontal-diagnosis-steps-text">
              Your dentist or hygienist will use pocket depths, amount of bleeding, inflammation, tooth mobility, etc., to make a diagnosis that will fall into a category below:
            </p>
            <h4 className="periodontal-diagnosis-steps-subheader">Gingivitis</h4>
            <p className="periodontal-diagnosis-steps-text">
              Gingivitis is the first stage of periodontal disease.  Plaque and its toxin by-products irritate the gums, making them tender, inflamed, and likely to bleed.
            </p>
            <h4 className="periodontal-diagnosis-steps-subheader">Periodontitis</h4>
            <p className="periodontal-diagnosis-steps-text">
              Plaque hardens into calculus (tartar).  As calculus and plaque continue to build up, the gums begin to recede from the teeth.  Deeper pockets form between the gums and teeth and become filled with bacteria and pus.  
              The gums become very irritated, inflamed, and bleed easily.  Slight to moderate bone loss may be present.
            </p>
            <h4 className="periodontal-diagnosis-steps-subheader">Advanced Periodontitis</h4>
            <p className="periodontal-diagnosis-steps-text">
              The teeth lose more support as the gums, bone, and periodontal ligament continue to be destroyed.  Unless treated, the affected teeth will become very loose and may be lost.  
              Generalized moderate to severe bone loss may be present. Read the section below to learn more about the types of advanced periodontal disease.
            </p>
          </div>
        </div>

        <div className="second-row-diagnosis-container">
          <div className="periodontitis-advanced-types-container">
            <h3 className="periodontal-diagnosis-steps-header">Types of Advanced Periodontitis</h3>
            <ul className="periodontal-types-list">
              <li><strong>Chronic periodontitis:</strong> inflammation within supporting tissues cause deep pockets and gum recession.  It may appear the teeth are lengthening, but in actuality, the gums (gingiva) are receding.  This is the most common form of periodontal disease and is characterized by progressive loss of attachment, interspersed with periods of rapid progression.</li>
              <li><strong>Aggressive periodontitis:</strong> a form of gum disease occurs in an otherwise clinically healthy individual.  It is characterized by rapid loss of gum attachment, chronic bone destruction and familial aggregation.</li>
              <li><strong>Necrotizing periodontitis:</strong> a form of periodontal disease most often occurs in individuals suffering from systemic conditions such as HIV, immunosuppression and malnutrition.  Necrosis (tissue death) occurs in the periodontal ligament, alveolar bone and gingival tissues.</li>
              <li><strong>Periodontitis caused by systemic disease:</strong> a form of gum disease often begins at an early age.  Medical condition such as respiratory disease, diabetes and heart disease are common cofactors</li>
            </ul>
          </div>
        </div>  
      </div>
    </div>
  );
};

export default DiagnosisContent;